// extracted by mini-css-extract-plugin
export var closeButton = "_w-1";
export var container = "_w-0";
export var fullModalImage = "_w-2";